<template>
  <v-chip label
          size="small"
          :color="color"
          class="text-body-2"
  >
    {{ $t(`common.AppSignatureStatus.${status}`) }}
  </v-chip>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { SignatureStatus } from '@/common/utils/signatureStatus'

/**
 * Default Signature status
 * @displayName AppSignatureStatus
 */
export default defineComponent({
  name: 'AppSignatureStatus',
  props: {
    status: {
      type: String as PropType<SignatureStatus>,
      required: true,
    },
  },
  computed: {
    color (): string {
      switch (this.status) {
        case SignatureStatus.Sent: return 'primary'
        case SignatureStatus.Signed: return 'warning'
        case SignatureStatus.SignedByAll: return 'success'
        case SignatureStatus.Voided: return 'secondary'
        default: return 'primary'
      }
    },
  },
})
</script>

<!--<docs>-->
<!--```vue-->
<!--<template>-->
<!--  <div class="d-flex">-->
<!--    <AppSignatureStatus :signature="signature"/>-->
<!--  </div>-->
<!--</template>-->
<!--<script>-->
<!--  export default {-->
<!--    data () {-->
<!--      return {-->
<!--        signature: {-->
<!--          status: "signed",-->
<!--          mySignature: {-->
<!--            status: "signed",-->
<!--          }-->
<!--        },-->
<!--      }-->
<!--    },-->
<!--  }-->
<!--</script>-->
<!--```-->
<!--</docs>-->
